import { useContext } from 'preact/hooks';
import { FormFieldContext } from './FormFieldContext';

/**
 * Utility hook for consuming the FormFieldContext
 *
 * @returns The value of closest FormControl provider
 */
function useFormFieldContext() {
  return useContext(FormFieldContext);
}

export { useFormFieldContext };
